export const SUPER_ADMIN_PERMISSIONS = Object.freeze({
  DASHBOARD_VIEW: 'super_dashboard_view',
  COMPANIES_VIEW: 'super_companies_view',
  COMPANIES_MANAGE: 'super_companies_manage',
  COMPANIES_IMPERSONATE: 'super_companies_impersonate',
  EMPLOYEES_VIEW: 'super_employees_view',
  EMPLOYEES_MANAGE: 'super_employees_manage',
  ROLES_VIEW: 'super_roles_view',
  ROLES_MANAGE: 'super_roles_manage',
  SUBSCRIPTIONS_VIEW: 'super_subscriptions_view',
  SUBSCRIPTIONS_MANAGE: 'super_subscriptions_manage',
  PAYMENTS_VIEW: 'super_payments_view',
  PAYMENTS_MANAGE: 'super_payments_manage',
  PAYMENTS_APPROVE: 'super_payments_approve',
  RECEIPTS_VIEW: 'super_receipts_view',
  RECEIPTS_GENERATE: 'super_receipts_generate',
  PLANS_VIEW: 'super_plans_view',
  PLANS_MANAGE: 'super_plans_manage',
  ADDONS_VIEW: 'super_addons_view',
  ADDONS_MANAGE: 'super_addons_manage',
  CRM_VIEW: 'super_crm_view',
  CRM_MANAGE: 'super_crm_manage',
  SUPPORT_VIEW: 'super_support_view',
  SUPPORT_MANAGE: 'super_support_manage',
  REPORTS_VIEW: 'super_reports_view',
  REPORTS_EXPORT: 'super_reports_export',
  SETTINGS_VIEW: 'super_settings_view',
  SETTINGS_MANAGE: 'super_settings_manage',
});

const P = SUPER_ADMIN_PERMISSIONS;

export const SUPER_ADMIN_PERMISSION_GROUPS = Object.freeze([
  { key: 'dashboard', label: 'Dashboard', permissions: [P.DASHBOARD_VIEW] },
  { key: 'companies', label: 'Companies', permissions: [P.COMPANIES_VIEW, P.COMPANIES_MANAGE, P.COMPANIES_IMPERSONATE] },
  { key: 'employees', label: 'Employees & Roles', permissions: [P.EMPLOYEES_VIEW, P.EMPLOYEES_MANAGE, P.ROLES_VIEW, P.ROLES_MANAGE] },
  { key: 'subscriptions', label: 'Subscriptions', permissions: [P.SUBSCRIPTIONS_VIEW, P.SUBSCRIPTIONS_MANAGE] },
  { key: 'payments', label: 'Payments & Receipts', permissions: [P.PAYMENTS_VIEW, P.PAYMENTS_MANAGE, P.PAYMENTS_APPROVE, P.RECEIPTS_VIEW, P.RECEIPTS_GENERATE] },
  { key: 'plans', label: 'Plans & Add-ons', permissions: [P.PLANS_VIEW, P.PLANS_MANAGE, P.ADDONS_VIEW, P.ADDONS_MANAGE] },
  { key: 'crm', label: 'CRM', permissions: [P.CRM_VIEW, P.CRM_MANAGE] },
  { key: 'support', label: 'Support', permissions: [P.SUPPORT_VIEW, P.SUPPORT_MANAGE] },
  { key: 'reports', label: 'Reports', permissions: [P.REPORTS_VIEW, P.REPORTS_EXPORT] },
  { key: 'settings', label: 'Settings', permissions: [P.SETTINGS_VIEW, P.SETTINGS_MANAGE] },
]);

export const DEFAULT_SUPER_ADMIN_ROLES = Object.freeze([
  {
    key: 'super_finance_manager',
    name: 'Finance Manager',
    permissions: [
      P.DASHBOARD_VIEW, P.COMPANIES_VIEW, P.SUBSCRIPTIONS_VIEW,
      P.PAYMENTS_VIEW, P.PAYMENTS_MANAGE, P.PAYMENTS_APPROVE,
      P.RECEIPTS_VIEW, P.RECEIPTS_GENERATE, P.REPORTS_VIEW,
    ],
  },
  {
    key: 'super_support_manager',
    name: 'Support Manager',
    permissions: [
      P.DASHBOARD_VIEW, P.COMPANIES_VIEW, P.SUPPORT_VIEW, P.SUPPORT_MANAGE,
      P.CRM_VIEW, P.REPORTS_VIEW,
    ],
  },
  {
    key: 'super_crm_manager',
    name: 'CRM Manager',
    permissions: [
      P.DASHBOARD_VIEW, P.COMPANIES_VIEW, P.CRM_VIEW, P.CRM_MANAGE,
      P.SUPPORT_VIEW, P.REPORTS_VIEW,
    ],
  },
  {
    key: 'super_subscription_manager',
    name: 'Subscription Manager',
    permissions: [
      P.DASHBOARD_VIEW, P.COMPANIES_VIEW, P.SUBSCRIPTIONS_VIEW,
      P.SUBSCRIPTIONS_MANAGE, P.PLANS_VIEW, P.ADDONS_VIEW,
      P.PAYMENTS_VIEW, P.RECEIPTS_VIEW, P.REPORTS_VIEW,
    ],
  },
  {
    key: 'super_auditor',
    name: 'Read-only Auditor',
    permissions: [
      P.DASHBOARD_VIEW, P.COMPANIES_VIEW, P.EMPLOYEES_VIEW, P.ROLES_VIEW,
      P.SUBSCRIPTIONS_VIEW, P.PAYMENTS_VIEW, P.RECEIPTS_VIEW,
      P.PLANS_VIEW, P.ADDONS_VIEW, P.CRM_VIEW, P.SUPPORT_VIEW,
      P.REPORTS_VIEW, P.SETTINGS_VIEW,
    ],
  },
]);

export const ALL_SUPER_ADMIN_PERMISSIONS = Object.freeze(
  Array.from(new Set(SUPER_ADMIN_PERMISSION_GROUPS.flatMap((group) => group.permissions)))
);
